// extracted by mini-css-extract-plugin
export default {"inputTitleWrapper":"discountInput_inputTitleWrapper__f+7w-","segmented":"discountInput_segmented__-5nwL"};